import React from 'react';

const ContactMap = () => {
    return (
        <div className="contact_map mt-10">
            <div className="map-area">
                <div style={{ position: "relative", overflow: "hidden", width: "100%", height: "100%" }}>
                    <a
                        href="https://yandex.ru/maps/org/sever_les/135301421174/?utm_medium=mapframe&utm_source=maps"
                        style={{ color: "#eee", fontSize: "12px", position: "absolute", top: "0px" }}
                    >
                        Север лес
                    </a>
                    <a
                        href="https://yandex.ru/maps/1/moscow-and-moscow-oblast/category/lumber/184106580/?utm_medium=mapframe&utm_source=maps"
                        style={{ color: "#eee", fontSize: "12px", position: "absolute", top: "14px" }}
                    >
                        Пиломатериалы в Москве и Московской области
                    </a>
                    <iframe
                        src="https://yandex.ru/map-widget/v1/org/sever_les/135301421174/?ll=38.732153%2C55.755126&z=15.78"
                        frameBorder="1"
                        allowFullScreen
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ContactMap;